import { render, staticRenderFns } from "./WaterfallMain.vue?vue&type=template&id=ea4bbfee&scoped=true&"
import script from "./WaterfallMain.vue?vue&type=script&lang=js&"
export * from "./WaterfallMain.vue?vue&type=script&lang=js&"
import style0 from "./WaterfallMain.vue?vue&type=style&index=0&id=ea4bbfee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4bbfee",
  null
  
)

export default component.exports